export default "__VITE_ASSET__e9a267de__"